import { render, staticRenderFns } from "./beer-keg.vue?vue&type=template&id=06bed09c"
import script from "./beer-keg.vue?vue&type=script&lang=js"
export * from "./beer-keg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports